import { type TableProps } from 'antd'
import {
  type FilterValue,
  type TablePaginationConfig,
  type SorterResult
} from 'antd/es/table/interface'
import { useCallback } from 'react'

import { type Sorter } from '../models'
import { mapToSorterFromAntdTable } from '../utils'

/**
 * Antd Tableのソート変更をハンドリングするフック
 * @param onChangeSort ソート変更時のコールバック
 * @param _dataSource 型推論のためのデータソース（実行時は使用しません）
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useAntdTableSort = <T = any>(
  onChangeSort: (sorter: Sorter) => void,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _dataSource?: T[]
) => {
  const handleTableChange: TableProps<T>['onChange'] = useCallback(
    (
      _: TablePaginationConfig,
      __: Record<string, FilterValue | null>,
      sorterResult: SorterResult<T> | SorterResult<T>[]
    ) => {
      const sorter = mapToSorterFromAntdTable(sorterResult)
      if (sorter) onChangeSort(sorter)
    },
    [onChangeSort]
  )

  return handleTableChange
}
